import goatIcon from "../../images/badges/the-goat.jpeg";
import topGunIcon from "../../images/badges/top-gun.jpeg";
import legendIcon from "../../images/badges/legend.jpeg";
import conquerorIcon from "../../images/badges/conqueror.jpeg";
import achieversIcon from "../../images/badges/achievers.jpeg";
import winnerIcon from "../../images/badges/winner.jpeg";
import profIcon from "../../images/badges/professional.jpeg";
import risingStarIcon from "../../images/badges/rising-star.jpeg";
import hunterIcon from "../../images/badges/hunter.jpeg";
import learnerIcon from "../../images/badges/learner.jpeg";

 const Badges = [
  { range: [501, 1000], name: "GOAT", icon: goatIcon },
  { range: [351, 500], name: "Top Gun", icon: topGunIcon },
  { range: [251, 350], name: "Legend", icon: legendIcon },
  { range: [201, 250], name: "Conqueror", icon: conquerorIcon },
  { range: [151, 200], name: "Achievers", icon: achieversIcon },
  { range: [101, 150], name: "Winner", icon: winnerIcon },
  { range: [71, 100], name: "Professional", icon: profIcon },
  { range: [41, 70], name: "Rising Star", icon: risingStarIcon },
  { range: [21, 40], name: "Hunter", icon: hunterIcon },
  { range: [0, 20], name: "Learner", icon: learnerIcon },
];


export default Badges;